import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class LeadsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'project_name'
      },
      {
        title: 'Address',
        dataIndex: 'address'
      },
      {
        title: 'Company',
        dataIndex: 'company'
      },
      {
        title: 'Primary Contact',
        dataIndex: 'primary_contact'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { leadsAddedData } = this.props

    const data = leadsAddedData.map((lead, index) => {
      // format date from db
      lead.created_date = moment(new Date(lead.created_date)).format('YYYY-M-D h:mm a')

      // format address
      lead.address = `${lead.address1 !== null && lead.address1}${
        lead.address2 !== null ? ' ' + lead.address2 : ''
      }${lead.city !== null ? ', ' + lead.city : ''}${
        lead.state !== null ? ' - ' + lead.state : ''
      }${lead.zip !== null ? ' - ' + lead.zip : ''}`

      // format primary contact name
      lead.primary_contact = `${lead.contact_first_name} ${lead.contact_last_name}`

      const returnObj = Object.assign({ key: `${lead.id}${index}` }, lead)
      delete returnObj.id
      return returnObj
    })
    return data
  }

  render() {
    const { loadingLeadsAdded, leadsAddedData } = this.props
    return (
      <div>
        {loadingLeadsAdded && !leadsAddedData && <Spin />}
        {!loadingLeadsAdded &&
          leadsAddedData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default LeadsAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/LeadsAdded.js